import { t, WithI18nLocale } from '@ardoq/i18n';
import { FlexBox } from '@ardoq/layout';
import { ReactNode } from 'react';

type TableControlsInteractiveRowProps = {
  children: ReactNode;
} & WithI18nLocale;

export const TableControlsInteractiveRow = ({
  children,
  i18nLocale,
}: TableControlsInteractiveRowProps) => {
  return (
    <FlexBox
      borderColor="borderSubtle"
      borderWidth={1}
      backgroundColor="bgSubtle"
      paddingY="small"
      // We want the background color of the row to spill to full width of main page
      // and escape its padding. Equals to padding large and 1px for the left border
      style={{ marginLeft: '-25px', marginRight: '-24px' }}
      paddingX="large"
      flex={1}
      gap="xsmall"
      align="center"
      flexWrap
      justify="space-between"
      role="toolbar"
      aria-label={t(
        i18nLocale,
        'inventory:interactiveRow.tableControls',
        'Table controls'
      )}
    >
      {children}
    </FlexBox>
  );
};
